// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';

import {Sequence} from 'components/Sequence';
import * as MapsConstants from 'constants/MapsConstants';
import * as mapsutil from 'molbio/maps/MapsUtil';
import * as selectables from 'molbio/maps/selectables/Selectables';
import SequencePrimer from 'molbio/primers/backbone/SequencePrimer';
import * as sequtil from 'molbio/SeqUtil';

class SequencePrimers extends selectables.Collection<SequencePrimer> {
  sequence!: Sequence;

  static initClass(): void {
    this.prototype.model = SequencePrimer;
  }

  initialize(models: Array<SequencePrimer>, options: {sequence: Sequence}): void {
    if (options == null) {
      // @ts-expect-error: this case should not be reached
      options = {};
    }
    // @ts-expect-error
    // eslint-disable-next-line prefer-rest-params
    super.initialize(...arguments);
    ({sequence: this.sequence} = options);
    this.setLayers();

    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.setLayers = this.batch(this.setLayers);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    return this.listenTo(this, 'add remove change:_primer change:visible reset', this.setLayers);
  }

  // @ts-expect-error: our Backbone types mark this as a property but it works fine as a method
  comparator(primer: SequencePrimer): number {
    return primer.start();
  }

  batchName(): string {
    return 'sequencePrimers';
  } // should match biojs/sequenceprimer.js

  getUnarchivedPrimers(): Array<SequencePrimer> {
    return this.filter((primer) => !primer.isArchived());
  }

  slice(start: number, end: number): Array<SequencePrimer> {
    const seqLength = this.sequence.length();
    if (seqLength === 0) {
      return [];
    }

    end %= seqLength;
    const data = this.getUnarchivedPrimers().filter((primer) => {
      const pStart = primer.drawStart(this.sequence);
      const pEnd = primer.drawEnd(this.sequence);
      // bases check is for new primers
      return (
        primer.get('visible') &&
        sequtil.isRangeOverlap(start, end, pStart, pEnd) &&
        primer.bases().length !== 0
      );
    });

    return _.sortBy(data, (primer) => {
      const x1 = Math.max(start, primer.get('_primer').start()) - start;
      const x2 = Math.min(end, primer.get('_primer').end()) - start;
      return x1 - x2;
    });
  }

  getCount(): number {
    return this.getUnarchivedPrimers().length;
  }

  setLayers(): void {
    const modelsAndLayers = mapsutil.getModelLayers(
      this.filter((primer) => primer.visible()),
      {
        top: false,
        sequence: this.sequence,
      }
    );
    for (const {model, layer} of Array.from(modelsAndLayers)) {
      model.set(MapsConstants.LINEAR_LAYER_FULL, layer, {silent: true});
    }
    this.trigger('layerChange');
  }
}
SequencePrimers.initClass();

export default SequencePrimers;
